import CopyTracking from "./woocommerce/myaccount/CopyTracking";
import CustomComplaints from "./woocommerce/myaccount/CustomComplaints";
import CustomRefunds from "./woocommerce/myaccount/CustomRefunds";
import CustomReviews from "./woocommerce/myaccount/CustomReviews";
import MyAccountLogin from "./woocommerce/myaccount/MyAccountLogin";
import PasswordEditForm from "./woocommerce/myaccount/PasswordEditForm";

const routes = {
  'moje-konto': MyAccountLogin,
  'reklamacja': CustomComplaints,
  'zwrot': CustomRefunds,
  'wystaw-opinie': CustomReviews,
  'edit-account': PasswordEditForm,
  'orders': CopyTracking,
};

window.addEventListener("DOMContentLoaded", () => {
  const urlSegments = window.location.pathname.split("/");
  const classes = urlSegments.map((segment) => routes[segment]).filter(Boolean);

  classes?.forEach(async (route) => {
    const instance = new route();
    if (instance.init) await instance.init();
  })
});
